import React from "react";

import ResponsiveModal from "../../components/ResponsiveModal";
import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "../../components/SoftButton";
import { formatNumber } from "../../helpers/formatter";
import { formatKpiPercent } from "../../helpers/scoreAggregate";

const cardTitleSx = {
  color: "#101828",
  fontFamily: "DM Sans",
  fontSize: "15px!important",
  fontWeight: "500!important",
  lineHeight: 1.4,
};

const cardBodySx = {
  margin: 0,
  color: "#344054",
  fontFamily: "DM Sans",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: 1.6,
};

/**
 * TeamYetiCard's "My Metrics Targets" dialog, shared by mobile and desktop.
 * Built on the shared ResponsiveModal shell — same chrome as the "View
 * Review" modal (title + bordered close button + divider, name/detail
 * card) — so it matches the rest of the app's modals at every viewport
 * instead of maintaining a separate glass-morphism layout for desktop.
 */
const fmt = (kpi, val) => (kpi.kind === "%" ? formatKpiPercent(kpi, val) : formatNumber(val, kpi.kind));

const MetricTargetsDialog = ({ open, onClose, kpis = [] }) => (
  <ResponsiveModal
    open={open}
    onClose={onClose}
    title="My Metrics Targets"
    maxWidth="sm"
    actions={
      <SoftButton variant="contained" color="primary" onClick={onClose}>
        Close
      </SoftButton>
    }
  >
    <SoftBox sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {kpis?.map((kpi) => (
        <SoftBox
          key={kpi._id}
          sx={{
            padding: "12px",
            border: "1px solid #EAECF0",
            borderRadius: "10px",
            backgroundColor: "#F9FAFB",
          }}
        >
          <SoftBox sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "8px", flexWrap: "wrap" }}>
            <SoftTypography sx={cardTitleSx}>{kpi?.title || "Unknown"}</SoftTypography>
            {kpi.metricType && !kpi.integrationId && (
              <SoftTypography sx={{ ...cardTitleSx, whiteSpace: "nowrap" }}>
                {fmt(kpi, kpi.target)}
              </SoftTypography>
            )}
          </SoftBox>

          {kpi.integrationId && !kpi.metricType && (
            <SoftTypography component="p" sx={{ ...cardBodySx, marginTop: "6px" }}>
              Daily Target: No Target, No Points
              <br />
              Current Value: {kpi.amount}
            </SoftTypography>
          )}

          {kpi.metricType === "progressive" && (
            <SoftTypography component="p" sx={{ ...cardBodySx, marginTop: "6px" }}>
              Daily Target: {fmt(kpi, kpi.target)}
              <br />
              Point Rule: For every {fmt(kpi, kpi.target)} you earn, you get {kpi.pointScale * kpi.target} points
            </SoftTypography>
          )}

          {kpi.metricType === "anchor" && (
            <SoftTypography component="p" sx={{ ...cardBodySx, marginTop: "6px" }}>
              Benchmark Target: {fmt(kpi, kpi.target)} = {kpi.optional.benchmarkPoint} points
              <br />
              {fmt(kpi, kpi.optional.point)} above the target, you Earn {kpi.optional.aboveBenchmark} points more
              <br />
              {fmt(kpi, kpi.optional.point)} below the target, you Loose {kpi.optional.belowBenchmark} points
            </SoftTypography>
          )}
        </SoftBox>
      ))}
    </SoftBox>
  </ResponsiveModal>
);

export default MetricTargetsDialog;
